import React from 'react';
import { useTranslation } from 'react-i18next';
import InputText from '@common_components/inputs/textInput.component';
import { SearchIcon } from '@umanforge/common';

interface SearchBarProps {
  searchedValue: string;
  setSearchedValue: ( newValue: string ) => void;
}

const SearchBarComponent: React.FC<SearchBarProps> = ( { searchedValue, setSearchedValue } ) => {
  const { t } = useTranslation();

  return (
    <>
      <InputText
        icon={<SearchIcon className='h-4 w-4' />}
        placeholder={ t( 'translation:umanforge_action_search' ) }
        value={ searchedValue }
        onChange={ setSearchedValue }
      />
    </>
  );
};

export { SearchBarComponent };
